export default __webpack_public_path__ + "91efed128c41426ad84593c66903721b.svg";